<template>
    <div class="main-wrapper">
        <layout-header />

        <div class="content container">
            <div class="px-3 pb-4">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Terrain {{ facility.name }} <span class="text-muted text-lg ml-1">({{ facility?.establishment?.business_name }})</span></h2>
                        </div>

                        <div class="tab-content pt-0">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Nom du Terrain</label>
                                        <input type="text" class="form-control" v-model="facility.name" required />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex flex-row align-items-center mt-1 mb-3">
                                        <img :src="previewUrl || defaultImage" class="mr-3" style="width: 120px;height: 70px;" />
                                        <div>
                                            <label class="btn btn-primary text-sm rounded-pill mr-3 mb-0">
                                                <b><i class="material-symbols-outlined text-sm mr-1">upload</i>
                                                    Importer l'image du terrain</b>
                                                <input type="file" class="d-none" @change="handleFileUpload"
                                                accept="image/*">
                                            </label>
                                            <div class="text-muted my-1">
                                                <p class="text-xs m-0">Allowed JPG, JPEG or PNG.</p>
                                                <p class="text-xs m-0">Max size of 6MB.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Sport</label>
                                        <select class="form-control custom-select" v-model="facility.sport_type" required>
                                            <option value="football">Football</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Type</label>
                                        <select class="form-control custom-select" v-model="facility.location_type" required>
                                            <option value="outdoor">En plein air</option>
                                            <option value="indoor">Couvert</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Surface</label>
                                        <select class="form-control custom-select" v-model="facility.surface_type" required>
                                            <option value="turf">Gazon</option>
                                            <option value="synthetic_turf">Gazon Synthétique</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Capacité</label>
                                        <select class="form-control custom-select" v-model="facility.capacity" required>
                                            <option value="10">5v5</option>
                                            <option value="12">6v6</option>
                                            <option value="14">7v7</option>
                                            <option value="16">8v8 et plus</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Durée (minutes)</label>
                                        <input type="number" class="form-control" v-model="facility.slot_duration" required />
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group card-label mb-3">
                                        <label>Prix</label>
                                        <input type="number" class="form-control" v-model="facility.price" required />
                                    </div>
                                </div>
                                <div class="col-md-8 h-100">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Description</label>
                                        <textarea type="text" class="form-control" rows="7"
                                            v-model="facility.description"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="submit-section">
                                <button type="submit" class="btn btn-primary btn-rounded px-4" @click.prevent="saveFacility">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Modifier</label>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <layout-footer />
    </div>
</template>
<style>
.nav-tabs.nav-justified > li > a {
    width: max-content;
}
</style>
<script>
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";
import defaultImagePath from '@/assets/img/photo.png'

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
    },
    props: ['facility_id'],
    data() {
        return {
            defaultImage: defaultImagePath,
            previewUrl: null,
            selectedFile: null,
            facility: {
                name: '',
                sport_type: 'football',
                location_type: 'outdoor',
                surface_type: 'synthetic_turf',
                capacity: '12'
            },
            establishment: {
                business_name: '',
                logo_url: '',
                vat_id: '',
                description: '',
                delegation: '',
                address: '',
                business_hours: []
            },
        }
    },
    mounted() {
        this.getEstablishment()
        this.getFacility()
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const maxSize = 6 * 1024 * 1024; // 6 MB in bytes
                if (file.size > maxSize) {
                    alert('File size exceeds the maximum limit of 6MB.');
                    event.target.value = null; // Clear the input
                    return;
                }
                this.selectedFile = file
                this.previewUrl = URL.createObjectURL(file)
            }
        },
        getEstablishment() {
            api.get('/private/establishment/')
                .then(response => {
                    const result = response.data
                    this.establishment = result
                })
        },
        getFacility() {
            api.get('/private/facilities/' + this.facility_id)
                .then(response => {
                    const result = response.data
                    this.facility = result
                    const featured_image = this.facility.images.filter(img => img.role === 'featured')
                    if (featured_image.length > 0) {
                        this.previewUrl = featured_image[0].thumb_small_url
                    }
                })
        },
        async saveFacility() {
            const formData = new FormData()
            this.facility.capacity = parseInt(this.facility.capacity)
            formData.append('form_data', JSON.stringify(this.facility))
            formData.append('featured_image', this.selectedFile)

            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            await api.put('/private/facilities/'+this.facility_id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: "Les informations du terrain ont été mises à jour avec succès.",
                        onResult: (confirmed) => {
                            if (confirmed) {
                                const userRole = this.currentUser?.role;
                                if (userRole === 'admin') {
                                    this.$router.push({ name: 'establishments' });
                                } else {
                                    this.$router.push({ name: 'owner-establishment' });
                                }
                            }
                        }
                    })
                    console.log('Facility added successfully');
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
    },
};
</script>
